const REPORT_TYPES = [
  'STUDENTS_WITHOUT_EMAIL',
  'LESSONS_TEACHER',
  'SECTIONS_GRADES',
  'STUDENT_SECTION_ENROLLED',
  'ACADEMIC',
  'LEARNING_RESULTS',
  'STUDENT_PROGRESS',
  'AUDIT_OF_GRADES',
  'STUDY_PLAN_ENROLLMENT_STATUS_HISTORY',
  'ACTIVE_TEACHERS',
  'TEACHERS_OCCUPATION',
  'SPACES_OCCUPATION',
  'AUDIT_OF_ATTENDANCE',
  'ENROLLED_WITHOUT_TUITION',
  'GRATUITY_LOSS',
] as const;
export type ReportType = typeof REPORT_TYPES[number];

export interface Report {
  id: number;
  name: string;
  description: string;
  downloadUrl: string;
  type: ReportType;
  renderSide: ExcelRenderSideEnum;
}

export interface ReportsResponse {
  data: Report[];
  total_pages: number;
  total: number;
}

export enum ExcelRenderSideEnum {
  Server = 'back',
  Client = 'front',
}
